// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-wrapper {
  text-align: center;
}

.no-plant-header-container {
  width: 100vw !important;
  height: 16rem;
  margin-left: 0;
  margin-bottom: 15px;
  overflow: hidden;
  border: none !important;
}
.no-plant-header-container .no-plant-header {
  padding: 0;
  position: relative;
  height: 100%;
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;
  border: none !important;
}
.no-plant-header-container .no-plant-header .icon-button-container {
  position: absolute;
  background-color: var(--ion-color-primary);
  height: 56px;
  width: 56px;
  border-radius: 50%;
  right: 10px;
  top: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.no-plant-header-container .no-plant-header .card-header-slanted-edge {
  position: absolute;
  bottom: 0;
  z-index: 1;
  width: 100%;
  right: 0;
  left: 0;
  border: none;
}
.no-plant-header-container .no-plant-header .card-header-slanted-edge svg .plant-testing {
  fill: #fff;
  stroke: rgb(255, 255, 255);
  stroke-width: 0px;
}

.main-content-container {
  width: 99vw;
}

.swiper,
.swiper-slide {
  border: none;
}

.plant-list-swiper-pagination {
  margin-bottom: 0;
  padding-bottom: 0;
}

.swiper-wrapper {
  margin-bottom: 30px;
}

.swiper-card {
  height: 250px;
  border: 1px solid var(--ion-color-primary);
  box-shadow: 0 0.5px 0 rgba(0, 0, 0, 0.1);
}
.swiper-card .swiper-card-header {
  padding: 20px;
  background-color: var(--ion-color-primary);
}
.swiper-card .swiper-card-header .swiper-card-title {
  font-size: 24px;
  font-weight: bold;
  margin: 0;
  color: #fff;
}
.swiper-card .swiper-card-content {
  padding: 20px;
}
.swiper-card .swiper-card-content .swiper-card-content p {
  margin-bottom: 10px;
}

@media (min-width: 320px) {
  .icon-button-container {
    top: 168px !important;
  }
}
@media (min-width: 340px) {
  .icon-button-container {
    top: 160px !important;
  }
}
@media (min-width: 410px) {
  .icon-button-container {
    top: 150px !important;
  }
}
@media (min-width: 430px) {
  .icon-button-container {
    top: 145px !important;
  }
}
@media (min-width: 500px) {
  .icon-button-container {
    top: 130px !important;
  }
}
@media (min-width: 576px) {
  .icon-button-container {
    top: 120px !important;
  }
}
@media (min-width: 600px) {
  .icon-button-container {
    top: 110px !important;
  }
}
@media (min-width: 680px) {
  .icon-button-container {
    top: 220px !important;
  }
  .no-plant-header-container {
    height: 24rem;
  }
}
@media (min-width: 720px) {
  .icon-button-container {
    top: 215px !important;
  }
}
@media (min-width: 820px) {
  .icon-button-container {
    top: 200px !important;
  }
}
@media (min-width: 900px) {
  .icon-button-container {
    top: 180px !important;
  }
}
@media (min-width: 1024px) {
  .icon-button-container {
    top: 208px !important;
  }
  .no-plant-header-container {
    height: 27rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/general components/plant-list/plant-list.component.scss","webpack://./src/components/general%20components/plant-list/plant-list.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;ACCF;;ADEA;EACE,uBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;ACCF;ADAE;EACE,UAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,wBAAA;EACA,4BAAA;EACA,uBAAA;ACEJ;ADAI;EACE,kBAAA;EACA,0CAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;ACEN;ADCI;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;ACCN;ADCM;EACE,UAAA;EACA,0BAAA;EACA,iBAAA;ACCR;;ADKA;EACE,WAAA;ACFF;;ADIA;;EAEE,YAAA;ACDF;;ADIA;EACE,gBAAA;EACA,iBAAA;ACDF;;ADGA;EACE,mBAAA;ACAF;;ADGA;EACE,aAAA;EACA,0CAAA;EACA,wCAAA;ACAF;ADEE;EACE,aAAA;EACA,0CAAA;ACAJ;ADEI;EACE,eAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;ACAN;ADGE;EACE,aAAA;ACDJ;ADGI;EACE,mBAAA;ACDN;;ADKA;EACE;IACE,qBAAA;ECFF;AACF;ADIA;EACE;IACE,qBAAA;ECFF;AACF;ADIA;EACE;IACE,qBAAA;ECFF;AACF;ADIA;EACE;IACE,qBAAA;ECFF;AACF;ADIA;EACE;IACE,qBAAA;ECFF;AACF;ADIA;EACE;IACE,qBAAA;ECFF;AACF;ADIA;EACE;IACE,qBAAA;ECFF;AACF;ADIA;EACE;IACE,qBAAA;ECFF;EDIA;IACE,aAAA;ECFF;AACF;ADIA;EACE;IACE,qBAAA;ECFF;AACF;ADKA;EACE;IACE,qBAAA;ECHF;AACF;ADKA;EACE;IACE,qBAAA;ECHF;AACF;ADKA;EACE;IACE,qBAAA;ECHF;EDKA;IACE,aAAA;ECHF;AACF","sourcesContent":[".btn-wrapper {\n  text-align: center;\n}\n\n.no-plant-header-container {\n  width: 100vw !important;\n  height: 16rem;\n  margin-left: 0;\n  margin-bottom: 15px;\n  overflow: hidden;\n  border: none !important;\n  .no-plant-header {\n    padding: 0;\n    position: relative;\n    height: 100%;\n    background-size: cover;\n    background-position: top;\n    background-repeat: no-repeat;\n    border: none !important;\n\n    .icon-button-container {\n      position: absolute;\n      background-color: var(--ion-color-primary);\n      height: 56px;\n      width: 56px;\n      border-radius: 50%;\n      right: 10px;\n      top: 70%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      z-index: 999;\n    }\n\n    .card-header-slanted-edge {\n      position: absolute;\n      bottom: 0;\n      z-index: 1;\n      width: 100%;\n      right: 0;\n      left: 0;\n      border: none;\n\n      svg .plant-testing {\n        fill: #fff;\n        stroke: rgb(255, 255, 255);\n        stroke-width: 0px;\n      }\n    }\n  }\n}\n\n.main-content-container {\n  width: 99vw;\n}\n.swiper,\n.swiper-slide {\n  border: none;\n}\n\n.plant-list-swiper-pagination {\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n.swiper-wrapper {\n  margin-bottom: 30px;\n}\n\n.swiper-card {\n  height: 250px;\n  border: 1px solid var(--ion-color-primary);\n  box-shadow: 0 0.5px 0 rgba(0, 0, 0, 0.1);\n\n  .swiper-card-header {\n    padding: 20px;\n    background-color: var(--ion-color-primary);\n\n    .swiper-card-title {\n      font-size: 24px;\n      font-weight: bold;\n      margin: 0;\n      color: #fff;\n    }\n  }\n  .swiper-card-content {\n    padding: 20px;\n\n    .swiper-card-content p {\n      margin-bottom: 10px;\n    }\n  }\n}\n@media (min-width: 320px) {\n  .icon-button-container {\n    top: 168px !important;\n  }\n}\n@media (min-width: 340px) {\n  .icon-button-container {\n    top: 160px !important;\n  }\n}\n@media (min-width: 410px) {\n  .icon-button-container {\n    top: 150px !important;\n  }\n}\n@media (min-width: 430px) {\n  .icon-button-container {\n    top: 145px !important;\n  }\n}\n@media (min-width: 500px) {\n  .icon-button-container {\n    top: 130px !important;\n  }\n}\n@media (min-width: 576px) {\n  .icon-button-container {\n    top: 120px !important;\n  }\n}\n@media (min-width: 600px) {\n  .icon-button-container {\n    top: 110px !important;\n  }\n}\n@media (min-width: 680px) {\n  .icon-button-container {\n    top: 220px !important;\n  }\n  .no-plant-header-container {\n    height: 24rem;\n  }\n}\n@media (min-width: 720px) {\n  .icon-button-container {\n    top: 215px !important;\n  }\n}\n\n@media (min-width: 820px) {\n  .icon-button-container {\n    top: 200px !important;\n  }\n}\n@media (min-width: 900px) {\n  .icon-button-container {\n    top: 180px !important;\n  }\n}\n@media (min-width: 1024px) {\n  .icon-button-container {\n    top: 208px !important;\n  }\n  .no-plant-header-container {\n    height: 27rem;\n  }\n}\n",".btn-wrapper {\n  text-align: center;\n}\n\n.no-plant-header-container {\n  width: 100vw !important;\n  height: 16rem;\n  margin-left: 0;\n  margin-bottom: 15px;\n  overflow: hidden;\n  border: none !important;\n}\n.no-plant-header-container .no-plant-header {\n  padding: 0;\n  position: relative;\n  height: 100%;\n  background-size: cover;\n  background-position: top;\n  background-repeat: no-repeat;\n  border: none !important;\n}\n.no-plant-header-container .no-plant-header .icon-button-container {\n  position: absolute;\n  background-color: var(--ion-color-primary);\n  height: 56px;\n  width: 56px;\n  border-radius: 50%;\n  right: 10px;\n  top: 70%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n.no-plant-header-container .no-plant-header .card-header-slanted-edge {\n  position: absolute;\n  bottom: 0;\n  z-index: 1;\n  width: 100%;\n  right: 0;\n  left: 0;\n  border: none;\n}\n.no-plant-header-container .no-plant-header .card-header-slanted-edge svg .plant-testing {\n  fill: #fff;\n  stroke: rgb(255, 255, 255);\n  stroke-width: 0px;\n}\n\n.main-content-container {\n  width: 99vw;\n}\n\n.swiper,\n.swiper-slide {\n  border: none;\n}\n\n.plant-list-swiper-pagination {\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.swiper-wrapper {\n  margin-bottom: 30px;\n}\n\n.swiper-card {\n  height: 250px;\n  border: 1px solid var(--ion-color-primary);\n  box-shadow: 0 0.5px 0 rgba(0, 0, 0, 0.1);\n}\n.swiper-card .swiper-card-header {\n  padding: 20px;\n  background-color: var(--ion-color-primary);\n}\n.swiper-card .swiper-card-header .swiper-card-title {\n  font-size: 24px;\n  font-weight: bold;\n  margin: 0;\n  color: #fff;\n}\n.swiper-card .swiper-card-content {\n  padding: 20px;\n}\n.swiper-card .swiper-card-content .swiper-card-content p {\n  margin-bottom: 10px;\n}\n\n@media (min-width: 320px) {\n  .icon-button-container {\n    top: 168px !important;\n  }\n}\n@media (min-width: 340px) {\n  .icon-button-container {\n    top: 160px !important;\n  }\n}\n@media (min-width: 410px) {\n  .icon-button-container {\n    top: 150px !important;\n  }\n}\n@media (min-width: 430px) {\n  .icon-button-container {\n    top: 145px !important;\n  }\n}\n@media (min-width: 500px) {\n  .icon-button-container {\n    top: 130px !important;\n  }\n}\n@media (min-width: 576px) {\n  .icon-button-container {\n    top: 120px !important;\n  }\n}\n@media (min-width: 600px) {\n  .icon-button-container {\n    top: 110px !important;\n  }\n}\n@media (min-width: 680px) {\n  .icon-button-container {\n    top: 220px !important;\n  }\n  .no-plant-header-container {\n    height: 24rem;\n  }\n}\n@media (min-width: 720px) {\n  .icon-button-container {\n    top: 215px !important;\n  }\n}\n@media (min-width: 820px) {\n  .icon-button-container {\n    top: 200px !important;\n  }\n}\n@media (min-width: 900px) {\n  .icon-button-container {\n    top: 180px !important;\n  }\n}\n@media (min-width: 1024px) {\n  .icon-button-container {\n    top: 208px !important;\n  }\n  .no-plant-header-container {\n    height: 27rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
